import React from 'react';
import { FormattedMessage, useIntl } from 'react-intl';
import { Form as FinalForm } from 'react-final-form';

import { useConfiguration } from '../../../context/configurationContext';
import Form from '../../Form/Form';
import { getPromotionOptions } from '../../../util/paymentHelpers';
import PaymentMethodField from '../../../containers/PaymentMethodsPage/PaymentMethodField/PaymentMethodField';
import FieldSelect from '../../FieldSelect/FieldSelect';
import { PROMOTION_DURATION } from '../../../constants/payment.constants';
import { PrimaryButton, SecondaryButton } from '../../Button/Button';
import { required } from '../../../util/validators';

import css from './PromotionForm.module.css';

const durationOptions = Object.values(PROMOTION_DURATION);

const getPromotionDurationToLabel = intl => {
  return {
    [PROMOTION_DURATION.WEEKLY]: intl.formatMessage({ id: 'PromotionForm.duration.weekly' }),
    [PROMOTION_DURATION.TWO_WEEKS]: intl.formatMessage({ id: 'PromotionForm.duration.twoWeeks' }),
    [PROMOTION_DURATION.MONTHLY]: intl.formatMessage({ id: 'PromotionForm.duration.monthly' }),
  };
};

const PromotionForm = props => {
  const config = useConfiguration();
  const intl = useIntl();
  return (
    <FinalForm
      {...props}
      render={formRenderProps => {
        const {
          className,
          handleSubmit,
          values,
          initialValues,
          dirty,
          onCancel,
          submitInProgress,
          promotion,
          promotionPrices,
        } = formRenderProps;
        const hasStripeKey = config.stripe.publishableKey;

        if (!hasStripeKey) return null;

        const PROMOTION_DURATION_TO_LABEL = getPromotionDurationToLabel(intl);

        return (
          <Form className={className} onSubmit={handleSubmit}>
            <FieldSelect
              id="duration"
              name="duration"
              label={intl.formatMessage({ id: 'Global.duration' })}
              validate={required(intl.formatMessage({ id: 'Global.required' }))}
            >
              {durationOptions.map(value => (
                <option value={value} key={value}>
                  {PROMOTION_DURATION_TO_LABEL[value]}
                </option>
              ))}
            </FieldSelect>
            <div className={css.fieldsWrapper}>
              {getPromotionOptions(intl, promotionPrices, values?.duration).map(
                ({ value, ...rest }) => (
                  <PaymentMethodField
                    className={css.paymentMethodField}
                    id={value}
                    key={value}
                    value={value}
                    name="plan"
                    title={intl.formatMessage({ id: `General.promotion.type.${value}` })}
                    {...rest}
                  />
                )
              )}
            </div>
            <div className={css.buttonsWrapper}>
              <PrimaryButton
                disabled={!values?.plan || (!!initialValues && !dirty)}
                className={css.button}
                inProgress={submitInProgress}
                type="submit"
              >
                <FormattedMessage id={`Global.${promotion ? 'change' : 'proceed'}`} />
              </PrimaryButton>
              <SecondaryButton type="button" className={css.button} onClick={onCancel}>
                <FormattedMessage id="Global.cancel" />
              </SecondaryButton>
            </div>
          </Form>
        );
      }}
    />
  );
};

export default PromotionForm;
